var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"vr_lock",class:{ 'voice-recorder-lock': true, 'locked': _vm.isLocked }},[_c('div',{class:{ 'thumb': true, 'locked': _vm.isLocked }})])])}
var staticRenderFns = []

export { render, staticRenderFns }